import { Component } from "@angular/core";
import { environment } from "src/environments/environment";
import { ThemeItemEnum } from "../../model/theme/contracts/theme-items.contract";
import {
  FormCompletionService,
  FormCompletionStates,
} from "../../services/form-completion/form-completion.service";

@Component({
  selector: "app-online-form",
  templateUrl: "./online-form.component.html",
  styleUrls: ["./online-form.component.scss"],
  providers: [FormCompletionService],
  standalone: false,
})
export class OnlineFormComponent {
  public states = FormCompletionStates;
  showPreviewMessage = false;

  ThemeItemEnum = ThemeItemEnum;

  public get isProduction() {
    return !!environment.production;
  }

  constructor(private formCompletionService: FormCompletionService) {
    this.showPreviewMessage = this.formCompletionService.formInstance?.isPreviewData || false;
  }

  // Helper function
  get service() {
    return this.formCompletionService;
  }
}
